export const ScoreBars = ({ scores, primary, secondary }) => (
  <div className="space-y-4" data-testid="score-bars">
    {scores.map((s) => {
      const tag = s.category === primary ? "Primary" : s.category === secondary ? "Secondary" : null;
      return (
        <div key={s.category} data-testid={`score-${s.category}`}>
          <div className="flex justify-between items-baseline gap-3 text-[15px]">
            <span className="text-[#3B121A] font-medium">{s.label}{tag && <span className="ml-2 text-[11px] uppercase tracking-[0.18em] text-[#B8902C]">{tag}</span>}</span>
            <span className="text-[#800534] font-semibold whitespace-nowrap" data-testid={`score-${s.category}-value`}>{s.score} / 20</span>
          </div>
          <div className="fea-progress mt-2">
            <div className={`fea-progress-bar ${tag ? "" : "opacity-50"}`} style={{ width: `${(s.score / 20) * 100}%` }} />
          </div>
        </div>
      );
    })}
  </div>
);
